import takeRequest from '~/store/takeRequest';
import * as AttendanceActions from './actions';

export function* attendanceSaga() {
  yield takeRequest(AttendanceActions.getAssistantSession);
  yield takeRequest(AttendanceActions.sendAssistantMessage);
}
